import { Paper, Typography } from '@mui/material';
import { useStyles } from './styles/Hint.styles';
export const Hint = ({ children, text }: { children?: React.ReactNode; text?: string | React.ReactNode }) => {
    const classes = useStyles();

    return (
        <Paper className={classes.hintContainer} elevation={4}>
            {text && <Typography variant={'h5'}>{text}</Typography>}
            {children}
        </Paper>
    );
};
